import React, { type MouseEventHandler } from "react";

import type { PatientRenewalInfo } from "@/models/PatientRenewalInfoModel.ts";
import { PatientCannotRenewButton } from "@/uiKit/molecules/CarePlan/PatientCannotRenewButton.tsx";
import { PatientRenewalButton, type RenewalDatasource } from "@/uiKit/molecules/CarePlan/PatientRenewalButton.tsx";

export type PatientRenewalActionProps = {
  renewalInfo: PatientRenewalInfo;
  dataSource: RenewalDatasource;
  onClick?: MouseEventHandler;
  className?: string;
};

export const PatientRenewalAction: React.FC<PatientRenewalActionProps> = ({
  renewalInfo,
  dataSource,
  onClick,
  className,
}) => {
  if (renewalInfo.canRenew) {
    return (
      <PatientRenewalButton
        className={className}
        dataSource={dataSource}
        renewalType={renewalInfo.renewalType}
        onClick={onClick}
      />
    );
  }
  return <PatientCannotRenewButton cannotRenewReason={renewalInfo.cannotRenewReason} dataSource={dataSource} />;
};
